import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectEditableRequirementTypes } from '../../../../../../../../../store/redux-store/placement-summary/selectors';
import { TransportationRow } from './TransportationTable';
import { ArrivalTime } from '@AMIEWEB/Placement/PlacementDetails/Edit/Components/ArrivalTime';
import { useArrivedFieldsetMeta } from '../useArrivedFieldsetMeta';
import { CustomTooltip } from '@AMIEWEB/Common';

export const TransportationArrivalTime = () => {
  const { t } = useTranslation();
  const { arrivalTime } = useSelector(selectEditableRequirementTypes);
  const fieldsetMeta = useArrivedFieldsetMeta();

  return (
    <TransportationRow
      id="placement-offer-transportation-arrivalTime"
      label={t('placement.profile.summary.offer.transportation.arrivalTime')}
      controlComponent={
        <CustomTooltip disabled={!fieldsetMeta.disabled} tooltipContent={fieldsetMeta.title} placement="bottom-start" arrow={false} isStandardContent>
          <ArrivalTime disabled={fieldsetMeta.disabled} />
        </CustomTooltip>
      }
      requirement={arrivalTime?.requirement}
    />
  );
};
